import React from 'react';

function FormContactUs() {
    return (
        <div className="pt-35px mt-45px border-t border-neutrals-700 mb-4">
            <p className="mb-4 text-neutrals-400 paragraph-3">Kontaktieren Sie uns</p>

            <p className="mb-1 paragraph-2 font-light text-white">Hotline</p>
            <div className="flex flex-col lg:flex-row lg:items-center gap-6 mb-1">
                <a href={`tel:${window.company_phone}`} className="flex items-center gap-2">
                    <img src='/images/icon_phone-empty.png' alt="Telefon" className="w-6 h-6" />
                    <p className="text-24">{window.company_phone}</p>
                </a>

                <a href={window.company_whatsapp} className="flex items-center gap-2">
                    <img src='/images/socials/icon_whatsapp.png' alt="WhatsApp" className="w-6 h-6" />
                    <p className="text-whatsapp text-24">WhatsApp</p>
                </a>
            </div>

            <p className="mb-7 text-neutrals-400 paragraph-5">(Mo-Fr: 9:00&nbsp;–&nbsp;17:00 Uhr)</p>
            <a href={`mailto:${window.company_email}`}><p className="mb-7 headline-6">{window.company_email}</p></a>

            <div className="flex gap-4">
                <a href={window.company_facebook} target="_blank" rel="noopener noreferrer">
                    <img src='/images/socials/fb-400.svg' alt="Facebook" className="pointer-events-none" />
                </a>
                <a href={window.company_instagram} target="_blank" rel="noopener noreferrer">
                    <img src='/images/socials/ig-400.svg' alt="Instagram" className="pointer-events-none" />
                </a>
            </div>
        </div>
    );
}

export default FormContactUs;
